import {callAPI} from '@/store/utils'; // eslint-disable-line

// Every route here is @check_roles(["SuperAdmin"]) and acts on another company,
// so company_id/user_id always travel in the body instead of coming from the token.
export default {
  namespaced: true,
  actions: {
    async actionEbicsListCredentials(_, {companyId, userId}) {
      const query = [`company_id=${encodeURIComponent(companyId)}`];
      if (userId) {
        query.push(`user_id=${encodeURIComponent(userId)}`);
      }
      return await callAPI(
        'GET',
        `ebics/credentials?${query.join('&')}`,
        {},
        true,
      );
    },
    async actionEbicsUserCompanies(_, {userId, search}) {
      const query = [`user_id=${encodeURIComponent(userId)}`];
      if (search) {
        query.push(`search=${encodeURIComponent(search)}`);
      }
      return await callAPI(
        'GET',
        `ebics/admin/user-companies?${query.join('&')}`,
        {},
        true,
      );
    },
    async actionEbicsInitialize(_, params) {
      return await callAPI('POST', 'ebics/initialize', params, true);
    },
    async actionEbicsSendIniHia(_, params) {
      return await callAPI('POST', 'ebics/send-ini-hia', params, true);
    },
    async actionEbicsSendIni(_, params) {
      return await callAPI('POST', 'ebics/send-ini', params, true);
    },
    async actionEbicsSendHia(_, params) {
      return await callAPI('POST', 'ebics/send-hia', params, true);
    },
    // No timeout: two Google Docs round-trips are slow and callAPI's timeout
    // path retries, which would generate the letters twice.
    async actionEbicsGenerateLetter(_, params) {
      return await callAPI('POST', 'ebics/generateLetter', params, true, 0);
    },
    async actionEbicsSendHpb(_, params) {
      return await callAPI('POST', 'ebics/send-hpb', params, true);
    },
    async actionEbicsValidateBankKeys(_, params) {
      return await callAPI('POST', 'ebics/validateBankKeys', params, true);
    },
    // No timeout: discovery runs a 360-day BTD, and callAPI's retry would take
    // the "already linked" branch and throw away the only copy of the IBAN list.
    async actionEbicsDiscoverIbans(_, params) {
      return await callAPI(
        'POST',
        'ebics/link-to-bank-connection',
        params,
        true,
        0,
      );
    },
    async actionEbicsCreateAccount(_, params) {
      return await callAPI('POST', 'ebics/link-to-bank-connection', params, true);
    },
    async actionEbicsProvisionCompanies(_, params) {
      return await callAPI('POST', 'ebics/provision-companies', params, true);
    },
    // No timeout: one pass per file and per sibling company. The retry is
    // harmless - messages already ingested are filtered per connection - but it
    // doubles the work and hides the real answer.
    async actionEbicsReplayBtdFile(_, params) {
      return await callAPI('POST', 'ebics/replay-btd-file', params, true, 0);
    },
  },
};
